import React, { Component } from "react";
import { Tag, Tooltip, Input, message } from "antd";
import { FilePdfOutlined, ToolOutlined } from "@ant-design/icons";
import { ButtonItem, SegmentedItem, TableItem } from "../../../../Components/Items";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import ModalPdfCMMS from "../componentes/ModalPdfCMMS";
import { cmmsPost, formatoFecha } from "../cmmsComun";
import { VIGENCIAS, etiquetaResultado } from "./certificadoComun";
import { generarPdfCertificado } from "./pdfCertificado";

// Certificados emitidos, por vigencia. Se emiten desde la Orden de Servicio (paso Certificados).
class CertificadosEmitidos extends Component {
    state = { loading: false, certificados: [], valor: "vigentes", clienteId: null, texto: "", pdf: null };

    componentDidMount() {
        this.consultar();
    }

    consultar = async () => {
        this.setState({ loading: true });
        try {
            const { valor, clienteId, texto } = this.state;
            const res = await cmmsPost(this.props, "selectCertificadosCMMS", { valor, clienteId, texto });
            this.setState({ certificados: res.data.success === 2 ? res.data.certificados : [] });
            if (res.data.success !== 2) message.error(res.data.message || "No se pudieron consultar los certificados");
        } catch (error) {
            console.log(error);
            message.error("No se pudieron consultar los certificados");
        } finally {
            this.setState({ loading: false });
        }
    };

    filtrar = (cambios) => this.setState(cambios, this.consultar);

    render() {
        const columns = [
            { title: "Folio", dataIndex: "codigo", key: "codigo", width: 110 },
            { title: "Certificado", dataIndex: "nombre", key: "nombre", width: 230, render: (v, r) => <span>{v}<div className="cmms-agenda-item-sub">{r.clave}</div></span> },
            { title: "Equipo", dataIndex: "equipoTexto", key: "equipoTexto", width: 260 },
            { title: "Cliente", dataIndex: "clienteNombre", key: "clienteNombre", width: 200 },
            { title: "O.S.", dataIndex: "servicioCodigo", key: "servicioCodigo", width: 110 },
            { title: "Fecha", dataIndex: "fecha", key: "fecha", width: 105, render: (v) => formatoFecha(v) },
            {
                title: "Vigente hasta",
                dataIndex: "vigenciaHasta",
                key: "vigenciaHasta",
                width: 190,
                render: (v, r) =>
                    r.estatus === 0 ? (
                        <Tooltip title={r.motivoCancelacion}>
                            <Tag color="default">Cancelado</Tag>
                        </Tooltip>
                    ) : (
                        <span>
                            {formatoFecha(v)} {r.estatusVigencia && <Tag color={VIGENCIAS[r.estatusVigencia].color}>{VIGENCIAS[r.estatusVigencia].label}</Tag>}
                            {r.renovado && r.estatusVigencia !== "vigente" ? (
                                <Tooltip title="El equipo ya tiene un certificado más reciente de este formato">
                                    <Tag color="blue">Renovado</Tag>
                                </Tooltip>
                            ) : null}
                        </span>
                    ),
            },
            { title: "Resultado", dataIndex: "cumple", key: "cumple", width: 130, render: (v, r) => <Tag color={etiquetaResultado(v, r.pendientes, r.otorgado).color}>{etiquetaResultado(v, r.pendientes, r.otorgado).label}</Tag> },
            { title: "Ingeniero", dataIndex: "ingeniero", key: "ingeniero", width: 170 },
            {
                title: "Acción",
                key: "accion",
                fixed: "right",
                align: "center",
                width: 100,
                onCell: () => ({ className: "acciones-sin-hover", style: { textAlign: "center", padding: "4px" } }),
                render: (r) => (
                    <div className="acciones-container">
                        <Tooltip title="Ver / descargar PDF">
                            <ButtonItem type="default" size="small" cyan icon={<FilePdfOutlined />} onClick={() => this.setState({ pdf: r })} />
                        </Tooltip>
                        <Tooltip title="Abrir la Orden de Servicio">
                            <ButtonItem type="default" size="small" blanco icon={<ToolOutlined />} onClick={() => this.props.history.push("/panel/cmmsServicio", { id: r.servicioId, paso: 3 })} />
                        </Tooltip>
                    </div>
                ),
            },
        ];
        return (
            <>
                <div className="cmms-filtros">
                    <SegmentedItem
                        options={[
                            { label: "Vigentes", value: "vigentes" },
                            { label: "Por vencer", value: "porVencer" },
                            { label: "Vencidos", value: "vencidos" },
                            { label: "Cancelados", value: "cancelados" },
                            { label: "Todos", value: "todos" },
                        ]}
                        value={this.state.valor}
                        onChange={(valor) => this.filtrar({ valor })}
                    />
                    <div style={{ width: 260 }}>
                        <SelectClientesItem
                            empresaId={this.props.empresaId}
                            headersToken={this.props.headersToken}
                            placeholder="Todos los clientes"
                            allowClear
                            width="100%"
                            value={this.state.clienteId || undefined}
                            onChange={(clienteId) => this.filtrar({ clienteId: clienteId || null })}
                        />
                    </div>
                    <Input.Search placeholder="Folio, equipo, serie, formato..." allowClear style={{ width: 260 }} onSearch={(texto) => this.filtrar({ texto })} />
                </div>
                <TableItem
                    loading={this.state.loading}
                    size="small"
                    dataSource={this.state.certificados}
                    columns={columns}
                    rowKey="_id"
                    pagination={true}
                    onRow={(r) => ({ onDoubleClick: () => this.setState({ pdf: r }) })}
                />
                <ModalPdfCMMS
                    visible={!!this.state.pdf}
                    titulo={`Certificado ${this.state.pdf?.codigo || ""}`}
                    nombreArchivo={`Certificado_${this.state.pdf?.codigo || ""}.pdf`}
                    generar={() => generarPdfCertificado(this.props, this.state.pdf._id)}
                    onClose={() => this.setState({ pdf: null })}
                />
            </>
        );
    }
}

export default CertificadosEmitidos;
